/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusQrcodeDto
 */
export interface NovitusQrcodeDto {
    /**
     * Typ kodu QR
     * @type {string}
     * @memberof NovitusQrcodeDto
     */
    qr_type: NovitusQrcodeDtoQrTypeEnum;
    /**
     * Zawartość kodu QR (max 271 znaków)
     * @type {string}
     * @memberof NovitusQrcodeDto
     */
    value: string;
}


/**
 * @export
 */
export const NovitusQrcodeDtoQrTypeEnum = {
    _0: '0',
    _1: '1'
} as const;
export type NovitusQrcodeDtoQrTypeEnum = typeof NovitusQrcodeDtoQrTypeEnum[keyof typeof NovitusQrcodeDtoQrTypeEnum];


/**
 * Check if a given object implements the NovitusQrcodeDto interface.
 */
export function instanceOfNovitusQrcodeDto(value: object): value is NovitusQrcodeDto {
    if (!('qr_type' in value) || value['qr_type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusQrcodeDtoFromJSON(json: any): NovitusQrcodeDto {
    return NovitusQrcodeDtoFromJSONTyped(json, false);
}

export function NovitusQrcodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusQrcodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'qr_type': json['qr_type'],
        'value': json['value'],
    };
}

export function NovitusQrcodeDtoToJSON(value?: NovitusQrcodeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'qr_type': value['qr_type'],
        'value': value['value'],
    };
}

